import { restClient } from 'config/store/configureStore';

import { LANGUAGES_URL } from 'constants/ApiConstants';

export default {
  getLanguages: () => restClient.get(LANGUAGES_URL),
};
